export type LoanCTA = 'RESUME_APPLICATION' | 'VIEW_DASHBOARD' | 'NO_CTA';
export type LoanRecord = {
  loanApplicationNumber: string;
  phone: string;
  customerName: string;
  journeyStatus: string;
  userEmail: string;
  pan: string;
  loanType: string;
  eligibleLoanAmount: string;
  loanAmountConfirmed: string;
  pledgedAmount: string;
  loanStartedAt: string;
  loanModifiedAt: string;
  referrerId?: string;
  partner: string;
  lid: string;
  cta: LoanCTA;
  unityUserId: string;
  lender: string;
};

export type LoanFiltersType = {
  pan: string;
  phone: string;
  loanApplicationNumber: string;
  fromDate: string;
  toDate: string;
  status: StatusTypes[];
  partner: string;
  referrers: string[];
  page: number;
  limit: number;
  sortByjourneyStatus?: 'asc' | 'desc' | '';
  sortByLoanStartedAt?: 'asc' | 'desc' | '';
  sortByLoanModifiedAt?: 'asc' | 'desc' | '';
  lid?: string;
};

// Status mapping
export const journeyStatus = {
  REGISTER_LEAD: 'Initiated registration',
  IMPORT_HOLDINGS: 'Importing Holdings',
  SELECT_LENDER: 'Selecting Lender',
  FETCH_CKYC: 'KYC verification',
  FETCH_CKYC_RENEWALS: 'KYC verification - renewals',
  CONFIRM_OFFER: 'Confirming Offer',
  LINK_BANK_ACCOUNT: 'Link Bank Account',
  PLEDGE_FUNDS: 'Pledging Funds',
  SIGN_AGREEMENT: 'Signing Agreement',
  VIDEO_KYC: 'Video KYC',
  SUBMITTED: 'Application Submitted',
  SUBMISSION_FAILED: 'Submission Failed',
  APPROVED: 'Application Approved',
  DISBURSEMENT_REQUESTED: 'Disbursement Initiated',
  DISBURSED: 'Loan Disbursed',
  CLOSED: 'Loan Closed',
  CANCELLED: 'Loan Cancelled',
  OPS_DIGILOCKER: 'KYC verification - ops',
  RESYNC_HOLDINGS: 'Resync holdings',
} as const;

type ValuesOf<T> = T[keyof T];

export type StatusTypes = ValuesOf<typeof journeyStatus> | string;

export const getStatusLabel = (status: string): string =>
  (journeyStatus as Record<string, string>)[status] || status;

export const journeyStatusOptions = Object.entries(journeyStatus).map(
  ([key, value]) => ({
    value: key,
    label: getStatusLabel(value),
  }),
);
